import _ from 'lodash';
import { useContext } from 'react';
import { IWorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';

export function useWorldMarker(): IReturnuseWorldMarker {
    const ctxEdit = useContext(CtxEdit);

    function getSingleMarkerIfOne(): IWorldMarker | null {
        if (ctxEdit.selectedMarkers.length === 1) {
            return getMarkerById(ctxEdit.selectedMarkers[0]);
        } else {
            return null;
        }
    }

    function getMarkerById(id: string): IWorldMarker | null {
        return _.find(ctxEdit.worldMarkers, (marker) => {
            return marker.id === id;
        });
    }

    function findHighestOrder(): number {
        const order = Math.max(
            ...Object.values(ctxEdit.worldMarkers).map((marker) => marker.order)
        );
        if (order === -Infinity || order === Infinity) {
            return 0;
        }
        return order;
    }

    function findLowestOrder(): number {
        const order = Math.min(
            ...Object.values(ctxEdit.worldMarkers).map((marker) => marker.order)
        );
        if (order === -Infinity || order === Infinity) {
            return 0;
        }
        return order;
    }

    return {
        getMarkerById,
        findHighestOrder,
        findLowestOrder,
        getSingleMarkerIfOne
    };
}

export interface IReturnuseWorldMarker {
    getMarkerById: (id: string) => IWorldMarker | null;
    findHighestOrder: () => number;
    findLowestOrder: () => number;
    getSingleMarkerIfOne: () => IWorldMarker | null;
}
